import { createReducer } from '@reduxjs/toolkit'

const initialState = {
  current_destination: 1,
  current_room_type: 1
}

const paginationReducer = createReducer(initialState, {
  SET_ROOM_TYPE: (state, action) => {
    return {
      ...state,
      current_room_type:
        state.current_room_type === action.payload ? null : action.payload
    }
  },
  SET_DESTINATION: (state, action) => {
    return {
      ...state,
      current_destination: action.payload
    }
  }
})

export default paginationReducer
